/* eslint-disable react/prop-types */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * DifficultTopicDetails
 *
 * @file DifficultTopicDetails.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DashboardCard from '../dashboardCard/DashboardCard';
import {
  ActionsLeftContainer,
  LeftColumnStack,
  LeftPanel,
  ReviewCardRoot,
  ReviewContentStyle,
  RightPanel
} from './styles/DifficultTopicStyles';
import QuestionDetailsCard from './QuestionDetailsCard';
import BehaviorTrendsCard from './BehaviourTrendsCard';

const DifficultTopicDetails = (props) => {
  const {
    onBackNavClick, config, assignmentName, components, classes
  } = props;
  const {
    showBackNav,
    showStrugglingStudents = false,
    backNavDataAttributes
  } = config;

  /**
   * Renders the struggling students component
   *
   * @returns {React.ReactNode}
   */
  const renderStrugglingStudentsTable = () => {
    if (!showStrugglingStudents) return null;

    const { StrugglingStudentsTableComp } = components || {};

    return (
      <Fragment>
        {StrugglingStudentsTableComp}
      </Fragment>
    );
  };

  return (
    <DashboardCard
      title={assignmentName}
      classes={classes}
      components={{
        Root: ReviewCardRoot,
        ActionsLeftContainer
      }}
      onBackNavClick={onBackNavClick}
      config={{ showBackNav, backNavDataAttributes }}
    >
      <ReviewContentStyle>
        <LeftColumnStack>
          <LeftPanel>
            <QuestionDetailsCard
              {...props}
            />
          </LeftPanel>
          {renderStrugglingStudentsTable()}
        </LeftColumnStack>
        <RightPanel>
          <BehaviorTrendsCard {...props} />
        </RightPanel>
      </ReviewContentStyle>
    </DashboardCard>
  );
};

DifficultTopicDetails.propTypes = {
  questions: PropTypes.array.isRequired,
  behaviorTrends: PropTypes.array.isRequired,
  mockQuestions: PropTypes.array,
  onFlaggedQuestionClick: PropTypes.func,
  onReviewItClick: PropTypes.func,
  assignmentName: PropTypes.string,
  config: PropTypes.shape({
    showBackNav: PropTypes.bool
  }).isRequired,
  textInfo: PropTypes.object.isRequired,
  components: PropTypes.shape({
    viewQuestions: PropTypes.node
  }),
  classes: PropTypes.object
};

DifficultTopicDetails.defaultProps = {
  assignmentName: '',
  onFlaggedQuestionClick: () => {},
  onReviewItClick: () => {},
  mockQuestions: [],
  components: null,
  classes: {}
};

export default DifficultTopicDetails;
